/*
 * @Date: 2023-12-29 15:29:59
 * @Author: jm
 * @LastEditTime: 2024-06-20 19:45:19
 * @LastEditors: jm
 * @FilePath: \arcadearchipelago\src\utils\request.js
 * @Description:
 */
// 1.首先引入 axios
import axios from "axios";
import { utils } from "../utils/utils.js";

let baseURL = "https://go.h5gameclubs.com/go/";

// if (window.location.href.indexOf("https") >= 0) {
//   baseURL = baseURL.replace("http", "https");
// }

// 2.创建一个实例
const api = axios.create({
  baseURL: baseURL, // 请求的公共地址部分
  timeout: 20000, // 请求超时时间 当请求时间超过5秒还未取得结果时 提示用户请求超时
  retry: 5, //设置全局重试请求次数（最多重试几次请求）
  retryDelay: 2000, //设置全局请求间隔
});

// 3axios的拦截器
// 请求相关处理 请求拦截 在请求拦截中可以补充请求相关的配置
// interceptors axios的拦截器对象
api.interceptors.request.use(
  (config) => {
    // config 请求的信息
    config.data = { data: utils.jim(JSON.stringify(config.data)) };
    // console.log(config.data);
    return config; // 将配置完成的config对象返回出去 如果不返回 请求则不会进行
  },
  (err) => {
    // 请求发生错误时的处理 抛出错误
    Promise.reject(err);
  }
);

// 4.response
api.interceptors.response.use(
  (res) => {
    // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
    // res 是所有相应的信息
    let shuju = utils.jem(res.data);
    if (shuju) {
      // console.log(JSON.parse(shuju));
      return JSON.parse(shuju);
    }

    // return Promise.resolve(res)
  },
  (err) => {
    var config = err.config; //获取超时的配置
    if (!config || !config.retry) {
      return Promise.reject(err);
    }
    // __retryCount用来记录当前是第几次发送请求
    config.__retryCount = config.__retryCount || 0;
    // 如果当前发送的请求大于等于设置好的请求次数时，不再发送请求，返回最终的错误信息
    if (config.__retryCount >= config.retry) {
      return Promise.reject(err);
    }
    // 记录请求次数+1
    config.__retryCount += 1;
    // 设置请求间隔 在发送下一次请求之前停留一段时间，时间为上方设置好的请求间隔时间
    var backoff = new Promise(function(resolve) {
      setTimeout(function() {
        resolve();
      }, config.retryDelay || 1);
    });
    // 再次发送请求
    return backoff.then(function() {
      return api(config);
    });
  }
);

// 5.暴露api
export default api;
